import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import './Account.css';

import { loadTransactions, selectTransactions, transactionsLoading } from '../transactionList/transactionsSlice.js';
import { selectAccounts } from '../manageAccounts/accountsSlice.js';
import { isLoggedIn, selectToken } from '../login/loginSlice.js';

import Sidebar from '../../components/sidebar/Sidebar.js';
import TransactionList from '../transactionList/TransactionList.js';
import EditTransactionForm from '../editTransactionForm/EditTransactionForm.js';
import { isEditTransactionFormActive } from '../editTransactionForm/editTransactionFormSlice.js';

export default function Account() {
    const { accountId } = useParams();

    const dispatch = useDispatch();

    const accounts = useSelector(selectAccounts);
    const account = accounts[accountId] ? accounts[accountId] : {accountId: "", accountType: "", balance: 0};
    const loggedIn = useSelector(isLoggedIn);
    const loadingTransactions = useSelector(transactionsLoading);
    const editTransactionFormIsActive = useSelector(isEditTransactionFormActive);

    const token = useSelector(selectToken);

    const navigate = useNavigate();

    useEffect(() => {
        if (!loggedIn) {
            navigate(`../login`);
        }
    }, [loggedIn, navigate])

    useEffect(() => {
        dispatch(loadTransactions({accountId, token}));
    }, [accountId, token, dispatch]);

    const transactions = useSelector(selectTransactions).filter(transaction => transaction.accountId.toString() === account.accountId);
    const pendingTransactions = transactions.filter(transaction => transaction.status === 'pending');
    const postedTransactions = transactions.filter(transaction => transaction.status === 'posted');

    return (
        <main>
            <Sidebar />
            <section className='account'>
                <h2>{account.accountType}</h2>
                {loadingTransactions ? <h3>Loading Transactions...</h3> :
                    <div>
                        <h3 className='balance'>Balance: ${account.balance.toFixed(2)}</h3>
                        <TransactionList type='pending' transactions={pendingTransactions} />
                        <TransactionList type='posted' transactions={postedTransactions} accountBalance={account.balance} />
                    </div>}
            </section>
            {editTransactionFormIsActive ? <EditTransactionForm /> : ""}
        </main>
    )
}